/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { LocationDivisionParentPathBase } from "../../../../schema/generated/LocationDivisionParentPath";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class LocationDivisionParentPathDataApi extends EntityDataApi<LocationDivisionParentPathBase> {
  public readonly def = idbEntityDefs.LocationDivisionParentPath;
}